import axios from 'axios';
import Constants from '../constants';
import { IColumn } from '../models';

export async function getColumns(): Promise<IColumn[]> {
	const res = await axios.get(Constants.API_SURVEYCOLUMNS_URL);
	return res.data;
}
